import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';

const PhoneDigitContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(4),
}));

const DigitBox = styled(Box)(({ theme, isFilled }) => ({
  width: '32px',
  height: '42px',
  border: `1px solid ${isFilled ? theme.palette.primary.main : 'rgba(255, 255, 255, 0.1)'}`,
  borderRadius: '4px',
  borderColor: "#fff",
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'rgba(255, 255, 255, 0.05)',
  backdropFilter: 'blur(10px)',
  color: '#fff',
  fontSize: '18px',
  transition: 'all 0.2s ease',
}));

const HiddenInput = styled('input')({
  position: 'absolute',
  opacity: 0,
  pointerEvents: 'none',
});

const PhoneInput = ({ value, onChange }) => {
  const inputRef = React.useRef(null);
  const digits = value.split('').concat(Array(10 - value.length).fill(''));

  const handleContainerClick = () => {
    inputRef.current && inputRef.current.focus();
  };

  const handleInputChange = (e) => {
    const input = e.target.value.replace(/\D/g, '').slice(0, 10);
    onChange('phoneNumber', input);
  };

  return (
    <Box onClick={handleContainerClick} sx={{ cursor: 'text', width: '100%' }}>
      <HiddenInput
        ref={inputRef}
        type="tel"
        value={value}
        onChange={handleInputChange}
        maxLength={10}
      />
      <PhoneDigitContainer>
        {digits.map((digit, index) => (
          <DigitBox key={index} isFilled={!!digit}>
            <Typography variant="body1">{digit}</Typography>
          </DigitBox>
        ))}
      </PhoneDigitContainer>
    </Box>
  );
};

export default PhoneInput;
